import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, ArrowUpRight, Phone } from "lucide-react";
import { VISTACION_URL, CONTACT } from "@/constants";

const NAV_LINKS = [
  { label: "Aircraft For Sale", to: "/aircraft-for-sale", testid: "nav-link-aircraft-for-sale" },
  { label: "Charter", to: "/enquire/charter", testid: "nav-link-aircraft-charter" },
  { label: "Empty Legs", to: "/empty-legs", testid: "nav-link-empty-legs" },
  { label: "Yachts", to: "/yachts", testid: "nav-link-yachts-for-sale" },
  { label: "Bullion", to: "/enquire/bullion", testid: "nav-link-bullion", wide: true },
  { label: "Membership", to: "/#membership", testid: "nav-link-membership" },
  { label: "Jet Account", to: "/#jet-account", testid: "nav-link-jet-account" },
  { label: "About", to: "/#about", testid: "nav-link-about", wide: true },
  { label: "Contact", to: "/#contact", testid: "nav-link-contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const linkClass = "whitespace-nowrap text-[11px] uppercase tracking-[0.18em] text-white/60 transition-colors duration-300 hover:text-white";

  return (
    <header data-testid="site-navbar" className="fixed top-0 inset-x-0 z-50 bg-black/60 backdrop-blur-2xl border-b border-white/10">
      <div className="hidden lg:flex max-w-7xl mx-auto px-6 lg:px-10 h-8 items-center justify-end gap-6 text-[10px] uppercase tracking-[0.18em] text-white/40 border-b border-white/5">
        <a href={CONTACT.phoneTel} className="hover:text-gold transition-colors" data-testid="nav-phone-link">Call {CONTACT.phoneDisplay}</a>
        <a href={CONTACT.whatsappUrl} target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-testid="nav-whatsapp-link">WhatsApp {CONTACT.whatsappDisplay}</a>
        <a href={`mailto:${CONTACT.email}`} className="hover:text-gold transition-colors" data-testid="nav-email-link">{CONTACT.email}</a>
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-brand" className="font-serif text-xl tracking-wide text-white whitespace-nowrap">
          Aero Vista <span className="text-gold">Club</span>
        </Link>

        <nav className="hidden xl:flex items-center gap-5 ml-10">
          {NAV_LINKS.map((link) => (
            <Link key={link.to} to={link.to} data-testid={link.testid} className={`${linkClass} ${link.wide ? "hidden 2xl:inline" : ""}`}>{link.label}</Link>
          ))}
          <a href={VISTACION_URL} target="_blank" rel="noopener noreferrer" data-testid="nav-link-vistacoin"
             className="inline-flex items-center gap-1.5 whitespace-nowrap text-[11px] uppercase tracking-[0.18em] text-gold transition-colors duration-300 hover:text-gold-light">
            Vistacoin (VSC) <ArrowUpRight size={12} />
          </a>
          <Link to="/enquire/charter" data-testid="nav-request-flight-button"
                className="ml-1 whitespace-nowrap bg-gold text-black text-[11px] uppercase tracking-[0.18em] px-4 py-2 rounded-sm hover:bg-gold-light transition-colors">
            Request a Flight
          </Link>
        </nav>

        <div className="flex items-center gap-4 xl:hidden">
          <a href={CONTACT.phoneTel} aria-label="Call us" className="text-white/70 hover:text-gold" data-testid="nav-mobile-phone-link"><Phone size={18} /></a>
          <button data-testid="nav-mobile-toggle" aria-label="Toggle navigation menu" onClick={() => setOpen(!open)} className="text-white/80 hover:text-white transition-colors duration-300">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <nav data-testid="nav-mobile-menu" className="xl:hidden bg-black/90 backdrop-blur-2xl border-t border-white/10">
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV_LINKS.map((link) => (
              <Link key={link.to} to={link.to} data-testid={`mobile-${link.testid}`} onClick={() => setOpen(false)}
                    className="text-xs uppercase tracking-[0.2em] text-white/70 transition-colors duration-300 hover:text-white">{link.label}</Link>
            ))}
            <a href={VISTACION_URL} target="_blank" rel="noopener noreferrer" data-testid="mobile-nav-link-vistacoin"
               className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.2em] text-gold">Vistacoin (VSC) <ArrowUpRight size={12} /></a>
            <Link to="/enquire/charter" onClick={() => setOpen(false)} data-testid="mobile-nav-request-flight-button"
                  className="bg-gold text-black text-xs uppercase tracking-[0.2em] px-5 py-3 rounded-sm text-center">Request a Flight</Link>
            <div className="pt-4 border-t border-white/10 text-xs text-white/50 space-y-2">
              <a href={CONTACT.phoneTel} className="block">Call {CONTACT.phoneDisplay}</a>
              <a href={CONTACT.whatsappUrl} target="_blank" rel="noopener noreferrer" className="block">WhatsApp {CONTACT.whatsappDisplay}</a>
              <a href={`mailto:${CONTACT.email}`} className="block">{CONTACT.email}</a>
            </div>
          </div>
        </nav>
      )}
    </header>
  );
};
